import { render, staticRenderFns } from "./UpdateNoteDialog.vue?vue&type=template&id=f9f035be&"
import script from "./UpdateNoteDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports